import React from 'react';
import MyPic from '../Image/MyPic.jpeg';

function Sidebar() {
  return (
    <aside className="sidebar">
      <img src={MyPic} alt="Your Name" className="profile-picture" />
      <h1>Mohammad I Nusir</h1>
      <p className="mt-2">Web Developer | ML Expert | Composer </p>

      <nav className="sidebar-section">
        <ul>
          <li>
            <a href="#about">
              <i className="fas fa-user"></i> About
            </a>
          </li>
          <li>
            <a href="#skills">
              <i className="fas fa-tools"></i> Skills
            </a>
          </li>
          <li>
            <a href="#education">
              <i className="fas fa-graduation-cap"></i> Education
            </a>
          </li>
          <li>
            <a href="#experience">
              <i className="fas fa-briefcase"></i> Experience
            </a>
          </li>
          <li>
            <a href="#projects">
              <i className="fas fa-project-diagram"></i> Projects
            </a>
          </li>
          <li>
            <a href="#publications">
              <i className="fas fa-book-open"></i> publications
            </a>
          </li>
          <li>
            <a href="#music">
              <i className="fas fa-music"></i> Music
            </a>
          </li>
          {/* <li>
            <a href="#translations">
              <i className="fas fa-globe"></i> Translations
            </a>
          </li> */}
          <li>
            <a href="#blog">
              <i className="fas fa-blog"></i> Blog
            </a>
          </li>
        </ul>
      </nav>

      <section id="contact" className="sidebar-section">
        <h2>Contact</h2>
       <div style={{width: "max-content", fontSize:"large"}}>
        <p><i className="fas fa-envelope"></i> mohammad.nuseir@yahoo.com</p>
        <p><i className="fas fa-phone"></i> Phone: +962787966297</p>
        <p><i className="fab fa-linkedin"></i> LinkedIn: <a href="https://www.linkedin.com/in/mohammad-nusir-66b517140/">M.I.Nusir</a></p>
        <p><i className="fab fa-github"></i> GitHub: <a href="https://github.com/MohammadNusir">M.I.Nusir</a></p>
        <p><i className="fab fa-google"></i> Scholar: <a href="https://scholar.google.com/citations?user=Xrn_3yUAAAAJ&hl=en">Mohammad.Nusir</a></p>
        <p><i className="fab fa-youtube"></i> YouTube: <a href="https://www.youtube.com/@Misanthrope90">M.Nusir</a></p>
        </div>
      </section>
    </aside>
  );
}

export default Sidebar;
